import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-note-input',
    templateUrl: './note-input.component.html',
    imports: [SharedModule]
})
export class NoteInputComponent implements OnInit {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        min: number | null;
    @Input()
        max: number | null;
    @Input()
        placeholder: string;
    @Input()
        disabled: boolean;
    @Output()
        action = new EventEmitter<void>();

    ngOnInit(): void {
        if (this.min == null) {
            this.min = 0;
        }
        if (this.max == null) {
            this.max = Number.MAX_VALUE;
        }
    }

    onClick() {        
        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.valueChange.emit(this.value);
        this.action.emit(null);
    }
}
